<div class="relative w-full">
  @if (isDisabled) {
    <button
      id="{{ type.toLowerCase() + '_' + (energy ? energy : '') }}"
      class="bg-readonly flex justify-between items-center w-full h-9 text-sm rounded-md shadow-sm text-left border border-solid border-gray-300"
      >
      @if ((!value || value?.name === '') && (!value2 || value2?.name === '')) {
        <div class="pl-2 text-xs text-gray-400">
          {{ "global.selectA" | translate }}
        </div>
      }
      @if (
        value &&
        [
        'EnergySubtype',
        'IUnits',
        'IRange',
        'IComparisonType',
        'Application',
        'Model',
        'BatteryVersion',
        'BodyType',
        'UsageType',
        ].includes(type)
        ) {
        <div
          class="pl-2"
          >
          {{ value.name }}
        </div>
      }
      <div class="flex justify-center align-middle h-full mr-3">
        <svg class="w-4" viewBox="0 0 18 10" fill="none">
          <path d="M1 1L9 9L17 1" stroke="#252525" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </button>
  }

  @if (!isDisabled) {
    <button
      id="{{ type.toLowerCase() + '_' + (energy ? energy : '') }}"
      class="flex justify-between items-center w-full h-9 bg-white text-gray-800 text-sm rounded-md shadow-sm text-left cursor-pointer select-none border border-solid border-gray-300 focus:ring-1 focus:ring-gray-400"
      (mousedown)="displayDropdown()"
      (focusout)="looseFocus()"
      >
      @if (!value && !value2) {
        <div class="pl-2 text-xs text-gray-400">{{ "global.selectA" | translate }}</div>
      }
      @if (
        value &&
        [
        'EnergySubtype',
        'IUnits',
        'IRange',
        'IComparisonType',
        'Application',
        'Model',
        'BatteryVersion',
        'BodyType',
        'UsageType',
        ].includes(type)
        ) {
        <div
          class="pl-2"
          >
          {{ value.name }}
        </div>
      }
      @if (type === 'ICurrency') {
        <div class="pl-2">{{ value2.code }}</div>
      }
      <div class="flex justify-center align-middle h-full mr-3">
        <svg class="w-4" viewBox="0 0 18 10" fill="none" id="{{ type.toLowerCase() + '_arrow_' + (energy ? energy : '') }}">
          <path d="M1 1L9 9L17 1" stroke="#252525" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </button>
  }

  <ul
    class="absolute w-full pl-0 top-full z-10 mt-0.5 bg-white text-sm shadow-md max-h-80 rounded overflow-auto select-none"
    (mouseover)="isHovered = true"
    (mouseout)="isHovered = false"
    [hidden]="!toggleDropdown"
    >
    @if (
      [
      'EnergySubtype',
      'IUnits',
      'IRange',
      'IComparisonType',
      'Application',
      'Model',
      'BatteryVersion',
      'BodyType',
      'UsageType',
      ].includes(type)
      ) {
      <span
        >
        @for (item of items; track item; let index = $index) {
          <li
            class="flex justify-between text-gray-800 py-2 cursor-pointer hover:bg-zinc-100"
            id="{{ type.toLowerCase() + '_' + index + (energy ? energy : '') }}"
            (mousedown)="onSelect(item)"
            >
            <span class="pl-3 h-full">{{ item.name }}</span>
          </li>
        }
      </span>
    }
    @if (type === 'ICurrency') {
      <span>
        @for (item of items2; track item; let index = $index) {
          <li
            class="flex justify-between text-gray-800 py-2 cursor-pointer hover:bg-zinc-100"
            id="{{ type.toLowerCase() + '_' + index }}"
            (mousedown)="onSelect(item)"
            >
            <span class="pl-3 h-full">{{ item.code }}</span>
          </li>
        }
      </span>
    }
  </ul>
</div>
